import { baseTranslationsDe } from "./i18n/de";
import { baseTranslationsEn } from "./i18n/en";
import { knowledgeSpacesI18n } from "./knowledgeSpaces/i18n";
import { processMiningTranslations } from "./processMining/i18n";
import { productComplianceI18n } from "./productCompliance/i18n";
import { SFWTranslations } from "./shopFloorWalk/i18n";
import { warehouseTranslations } from "./warehouse/i18n";

type I18nMessages = Record<string, Record<string, unknown>>;

export function mergeMessages(...messageSets: I18nMessages[]): I18nMessages {
  const result: I18nMessages = {};

  messageSets.forEach((messages) => {
    Object.keys(messages).forEach((langCode) => {
      result[langCode] = {
        ...(result[langCode] ?? {}),
        ...messages[langCode],
      };
    });
  });

  return result;
}

const baseMessages = {
  de: baseTranslationsDe,
  en: baseTranslationsEn,
};

export default mergeMessages(
  baseMessages,
  warehouseTranslations,
  processMiningTranslations,
  knowledgeSpacesI18n,
  SFWTranslations,
  productComplianceI18n,
);
